namespace Areas.AccountModule.Edit {
    "use strict";

     var tabItems = Areas.createTabsWithSameAction("Account/Module", "Edit",
        ["ChangeManagement", "ContractorPay", "MeetingMinutes", "PunchList", "Submittal", "Transmittal", "Warranty"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

}